import _ from 'lodash'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
// import { Link } from 'react-router'

import {
  Form, Grid, Segment, Button,
  TextArea, Message, Modal, Tab, Radio
} from 'semantic-ui-react'
import { ResettableSelect } from '../components/ResettableSelect'

class TargetSelect extends PureComponent {
  static propTypes = {
    minions: PropTypes.object
  }
  render() {
    const {
      minions, ...remainingProps
    } = this.props

    const options = [{
      label: 'All Targets',
      text: '*',
      value:'*'
    }].concat(_.chain(minions).keys().map(m => ({text: m, value: m})).value())

    return (
      <Form.Select
        as={ResettableSelect}
        selectOnNavigation={false}
        resetOnValue={'*'}
        multiple={true} search
        options={options}
        placeholder={'* , all minions'}
        noResultsMessage={'No matching minions'}
        {...remainingProps} />
    )
  }
}

const getClientType = (client) => { return client.split('_')[0] }

class ClientSelect extends PureComponent {
  static propTypes = {
    availableClients: PropTypes.array
  }
  render () {
    const { availableClients, ...remainingProps } = this.props
    return (
      <Form.Select
        selectOnNavigation={false}
        options={_
          .chain(availableClients)
          .map(c => ({text: c, value: c})).value()}

        {...remainingProps} />
    )
  }
}

class FunctionSelect extends PureComponent {
  static propTypes = {
    functions: PropTypes.array
  }
  render () {
    const { functions, ...remainingProps } = this.props
    return (
      <Form.Select
        selectOnNavigation={false}
        options={_
          .chain(functions)
          .map(f => ({text: f, value: f})).value()}

        {...remainingProps} />
    )
  }
}

class ArgSpec extends PureComponent {
  static propTypes = {
    doc: PropTypes.string,
    argspec: PropTypes.object,
    argspecValues: PropTypes.object,
    argspecErrors: PropTypes.object,
    onChangeArgSpecValues: PropTypes.func
  }
  docInModal = () => {
    if(!_.isString(this.props.doc) || _.size(this.props.doc) === 0) {
      return <span>no documentation available</span>
    }
    // const docText = this.props.doc.replace(
    //     /([^\\])?\\n/g, '$1' + String.fromCharCode(13, 10))
    const docText = this.props.doc
    return (
      <Modal
        trigger={<Button size={'tiny'} onClick={(e) => e && e.preventDefault()}>Show Documentation</Button>}
        closeIcon size={'large'}>
        <Modal.Content>
          <pre>{docText}</pre>
        </Modal.Content>
      </Modal>
    )
  }


  render () {
    const {
      argspec, argspecValues, argspecErrors,
      onChangeArgSpecValues
    } = this.props
    console.log('ArgSpec', argspec)
    if(argspec === null) return null
    const rDefaults = _.reverse(Array.from(argspec.defaults||[]))
    const rArgs = _.reverse(Array.from(argspec.args||[]))
    const rFields = _.map(rDefaults, (rDef, i) => {
      const label = rArgs[i]
      const cVal = argspecValues[rArgs[i]]
      if (_.isBoolean(rDef)) {
        return (
          <Form.Checkbox
            inline key={label + `_${i}`}
            name={label}
            label={label}
            onChange={onChangeArgSpecValues}
            checked={_.isUndefined(cVal) ? rDef : cVal} />
        )
      } else {
        return (
          <Form.Input
            inline key={label + `_${i}`}
            name={label}
            defaultValue={_.isUndefined(cVal) ? '' : cVal}
            onBlur={onChangeArgSpecValues}
            label={label}
          />
        )
      }
    })
    if (_.size(rFields) < _.size(rArgs)) {
      _.forEach(_.slice(rArgs, _.size(rFields)), rArg => {
        const cVal = argspecValues[rArg]
        rFields.push(
          <Form.Input
            inline key={rArg} name={rArg} label={rArg} required
            defaultValue={_.isUndefined(cVal) ? '' : cVal}
            onBlur={onChangeArgSpecValues}
          />)
      })
    }
    const fields = _.reverse(rFields)
    if (argspec.varargs) {
      const cVal = argspecValues.varargs
      const cErr = argspecErrors.varargs
      fields.push(
        <Form.Field
          inline label={'varargs'} key={'varargs'} name={'varargs'}
          onBlur={onChangeArgSpecValues}
          control={TextArea}
          defaultValue={_.isUndefined(cVal) ? '' : cVal}
          error={cErr}
          placeholder={'A list of args as a JSON (e.g. ["arg1","arg2" ...])'} />
      )
      fields.push(
        <Message
          hidden={!cErr} error attached={'bottom'} key={'message_varargs'}
          header={'Invalid varargs'}
          content={'varargs fields has to be a valid JSON list expression'} />
      )
    }
    if (argspec.kwargs) {
      const cVal = argspecValues.kwargs
      const cErr = argspecErrors.kwargs
      fields.push(
        <Form.Field
          inline label={'kwargs'} key={'kwargs'} name={'kwargs'}
          onBlur={onChangeArgSpecValues}
          defaultValue={_.isUndefined(cVal) ? '' : cVal}
          error={cErr}
          control={TextArea}
          placeholder={'A dict of kwargs as a JSON (e.g. {"arg1":"val1","arg2":"val2" ...}'} />
      )
      fields.push(
        <Message
          hidden={!cErr} error attached={'bottom'} key={'message_kwargs'}
          header={'Invalid kwargs'}
          content={'kwargs fields has to be a valid JSON object expression'}
        />
      )
    }
    return <Segment.Group>
      <Segment>{this.docInModal()}</Segment>
      <Segment>{fields}</Segment>
    </Segment.Group>
  }
}

class OutputArea extends PureComponent {
  static propTypes = {
    out: PropTypes.object,
  }
  state = {
    asTabs: true
  }

  prettyOut = (out) => {
    return JSON
      .stringify(out, null, 2)
      .replace(/([^\\])?\\n/g, '$1' + String.fromCharCode(13, 10))
      .replace(/^"(.*)"$/g, '$1')
  }

  renderTextArea = (out) => {
    return (
      <TextArea
        readOnly autoHeight
        style={{
          minWidth: '100%',
          minHeight: '100%',
          resize: 'none',
          backgroundColor: 'DimGrey',
          color: 'white'
        }} value={this.prettyOut(out)} />
    )
  }

  renderAsTabs = () => {
    return (
      <Tab
        menu={{ attached: true, tabular: true}}
        panes={_
          .chain(this.props.out)
          .map((out, mid) => ({
            menuItem: mid,
            render: () => <Tab.Pane>{this.renderTextArea(out)}</Tab.Pane>
          }))
          .value()
        } />
    )
  }
  render() {
    return (
      <div>
        <Radio
          toggle label={'as tabs'} checked={this.state.asTabs}
          style={{float: 'right', marginBottom: '15px'}}
          onClick={() => this.setState({asTabs: !this.state.asTabs})} />
        {this.state.asTabs ? this.renderAsTabs() : this.renderTextArea(this.props.out)}
      </div>
    )
  }
}

export class JobRunForm extends PureComponent {
  static propTypes = {
    onChangeTarget: PropTypes.func,
    onChangeClient: PropTypes.func,
    onChangeFunction: PropTypes.func,
    onChangeArgSpecValues: PropTypes.func,
    onSubmit: PropTypes.func,
    doc: PropTypes.string,
    argspec: PropTypes.object,
    argspecValues: PropTypes.object,
    argspecErrors: PropTypes.object,
    availableClients: PropTypes.array,
    minions: PropTypes.object,
    functions: PropTypes.object,
    runner_functions: PropTypes.object,
    client: PropTypes.string,
    tgt: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    fun: PropTypes.string,
    runningJob: PropTypes.bool,
    validationMessage: PropTypes.string,
    fieldsErrors: PropTypes.object,
    onMessageErrorsDismiss: PropTypes.func,
  }

  render () {
    const {
      availableClients,
      minions,
      functions,
      runner_functions,
      client, tgt, fun
    } = this.props
    console.log('JobRunForm render', this.props, this.state)

    return (
      <Form
        onSubmit={this.props.onSubmit}
        error={!_.isNil(this.props.validationMessage)}>

        <Message
          floating error content={this.props.validationMessage}
          onDismiss={this.props.onMessageErrorsDismiss} />

        <ClientSelect
          availableClients={availableClients}
          value={client} search
          onChange={this.props.onChangeClient} />

        <TargetSelect
          minions={minions} value={tgt}
      onChange={this.props.onChangeTarget} />

      <FunctionSelect
        error={this.props.fieldsErrors.fun || false}
        functions={(getClientType(client) === 'runner' ? _
          .keys(runner_functions) : _.keys(functions))}
        value={fun} search
        onChange={this.props.onChangeFunction} />

      {client.startsWith('local') && _.size(fun) > 0 &&
       <ArgSpec
         argspec={functions[fun].argspec} doc={functions[fun].doc}
         onChangeArgSpecValues={this.props.onChangeArgSpecValues}
         argspecValues={this.props.argspecValues}
         argspecErrors={this.props.argspecErrors}
       />
      }

      <Form.Button loading={this.props.runningJob} content="Run Job" />
      </Form>
    )
  }

}

export class JobRun extends PureComponent {
  static contextTypes = {
    app: PropTypes.shape({
      actions: PropTypes.objectOf(PropTypes.func),
    })
  }
  static propTypes = {
    docs: PropTypes.object,
    minions: PropTypes.object,
    availableClients: PropTypes.array
  }
  state = {
    client: 'local',
    tgt: ['*'],
    fun: '',
    arg: null,
    kwarg: null,
    out: null,
    argspecValues: {},
    argspecErrors: {},
    runningJob: false,
    validationMessage: null,
    fieldsErrors: {}
  }

  onChangeArgSpecValues = (evt, data) => {
    const { argspecValues, argspecErrors } = this.state
    let { name, type, value:val } = data || evt.currentTarget || {}
    console.log(
      `JobRun.onChangeArgSpecValues event ${evt.name} on:`,
      name, type, data)
    if (type === 'checkbox')
      val = data.checked
    else if (type === 'text') {
      console.log(name, type, val) // val = data.value
    } else if (type === 'textarea' && evt.type === 'blur') {
      // check if we are on textarea
      console.log(name, type, val) // val = evt.currentTarget.value
      try {
        val = JSON.parse(evt.currentTarget.value)
        if(_.negate(_.isString)(val) || _.size(val) > 0) {
          if(name === 'varargs' && !_.isArray(val))
            throw new Error('invalid varargs')
          if(name === 'kwargs' && !_.isPlainObject(val))
            throw new Error('invalid kwargs')
        }
        return this.setState({
          argspecErrors: {...argspecErrors, [name]:false},
          argspecValues: {...argspecValues, [name]:val}
        })

      } catch (e) {
        console.log(
          `JobRun.onChangeArgSpecValues Error on ${name}`,
          evt.currentTarget.value)
        return this.setState({
          argspecErrors: {...argspecErrors, [name]:true},
          argspecValues: {...argspecValues, [name]:''}
        })
      }
    } else {

      console.log(
        'JobRun.onChangeArgSpecValues unmanage field',
        this.props.docs.functions[this.state.fun].argspec,
        name, type, val)
      return
    }
    console.log(
      'JobRun.onChangeArgSpecValues',
      this.props.docs.functions[this.state.fun].argspec,
      name, type, val)
    this.setState({argspecValues: {...argspecValues, [name]:val }})
  }

  onMessageErrorsDismiss = () => { this.setState({validationMessage: null}) }

  onSubmit = (e, formInstance) => {
    console.log(e, formInstance.children)
    e && e.preventDefault()

    const simpleValues = _
      .chain(formInstance.children)
      .map(c => {
        if (c.type === ClientSelect)
          return ['client', c.props.value]
        if (c.type === TargetSelect)
          return ['tgt', c.props.value]
        if (c.type === FunctionSelect)
          return ['fun', c.props.value]
        return null
      })
      .filter()
      .fromPairs()
      .value()

    // TODO validation
    console.log('onSubmit', simpleValues)
    if (_.size(simpleValues.fun) === 0) {
      this.setState({fieldsErrors: {...this.state.fieldsErrors, fun:true}})
      this.setState({validationMessage: 'Function field is required'})
      return
    }

    this.setState({
      validationMessage: null,
      fieldsErrors: {}
    })
    if(_.isFunction(this.context.app.actions.doRunJob)) {
      this.setState({runningJob: true})
      const params = _.pick(this.state, ['client', 'fun', 'tgt'])
      if (_.isArray(params.tgt)) {
        params.tgt = params.tgt.join(',')
        params.expr_form = params.tgt === '*' ? 'glob' : 'list'
      }
      params.kwarg = _
        .chain(this.state.argspecValues)
        .toPairs()
        .filter(item => (
          item[0] !== 'kwargs' &&
          item[0] !== 'varargs' &&
          (!_.isString(item[1]) || _.size(item[1]) > 0)))
        .fromPairs()
        .value()
      if (_.isPlainObject(this.state.argspecValues.kwargs))
        params.kwarg = {...this.state.argspecValues.kwargs, ...params.kwarg}
      if (_.isArray(this.state.argspecValues.varargs))
        params.arg = _.map(this.state.argspecValues.varargs)

      this.context.app.actions.doRunJob(params).then(
        res => this.setState({out: res, runningJob: false}))
    }
  }

  onChangeClient = (...args) => {
    const value = _.size(args) === 1 ? args[0].value : args[1].value
    console.log('onChangeClient', value, args)
    if (getClientType(this.state.client) !== getClientType(value))
      this.setState({
        client:value, fun:'', argspecValues: {}, argspecErrors: {}
      })
    else this.setState({client:value})
  }

  onChangeTarget = (...args) => {
    const value = _.size(args) === 1 ? args[0].value : args[1].value
    console.log('onChangeTarget', value, args)
    this.setState({tgt:value})
  }

  onChangeFunction = (...args) => {
    const value = _.size(args) === 1 ? args[0].value : args[1].value
    this.setState({fieldsErrors: {fun: _.size(value) === 0}})
    console.log('onChangeFunction', value, args)
    this.setState({fun:value, argspecValues: {}, argspecErrors: {}})
  }

  render () {
    const docs = this.props.docs || {}
    const actions = this.context.app.actions || {}
    console.log('JobRun render', this.props, this.state)
    return (
      <Grid style={{minHeight: '100%'}} columns="equal" stackable>
        <Grid.Column stretched width={4}>
          <JobRunForm
            minions={this.props.minions}
            availableClients={this.props.availableClients}
            functions={docs.functions}
            runner_functions={docs.runners}
            onSubmit={this.onSubmit}
            onMessageErrorsDismiss={this.onMessageErrorsDismiss}
            getArgSpec={actions.getArgSpec}
            getDoc={actions.getDoc}
            onChangeClient={this.onChangeClient}
            onChangeTarget={this.onChangeTarget}
            onChangeFunction={this.onChangeFunction}
            onChangeArgSpecValues={this.onChangeArgSpecValues}
            {...this.state}
          />
        </Grid.Column>
        <Grid.Column stretched>
          {_.isNil(this.state.out) ? null : <OutputArea out={this.state.out} />}
        </Grid.Column>
      </Grid>
    )
  }
}

export default JobRun



// WEBPACK FOOTER //
// ./src/components/JobRun.js